import styled from 'styled-components/macro';
import { Images } from 'assets/images';
import { deviceMax, deviceMin } from 'utils/styles/breakpoints';
import { BaseContentContainer } from 'utils/baseElements';
import { ELEMENTS } from '../core';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyledMainSection = styled(ELEMENTS.Section)`
  height: 854px;
  min-width: 100%;
  background-size: cover;
  background-image: url(${Images.mainBgImage});

  @media ${deviceMax.laptopM} {
    height: 654px;
  }

  @media ${deviceMax.tablet} {
    height: 1024px;
    background-size: cover;
    background-position: center;
  }

  @media ${deviceMax.mobileL} {
    height: 568px;
  }
`;

export const ModalWrapper = styled.div``;

export const Content = styled.div`
  .slick-slider .slick-track,
  .slick-slider .slick-list {
    @media ${deviceMin.mobileS} {
      height: 676px;
      position: relative;
    }

    @media ${deviceMin.tablet} {
      position: relative;
    }

    @media ${deviceMin.laptopL} {
      height: 654px;
      position: relative;
    }

    @media ${deviceMin.desktop} {
      height: 1014px;
      position: relative;
    }
  }
`;

export const ContentContainer = styled(BaseContentContainer)`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  width: 382px;
  height: 272px;
  background: ${COLORS.multiGray_op9};
  border-radius: 10px;
  position: absolute;
  top: 40%;
  transform: translateY(-45%);
  align-items: unset;

  @media ${deviceMin.mobileS} {
    padding: 10px 22px;
    width: 260px;
    height: 280px;
    margin: 0 24px;
  }

  @media ${deviceMin.mobileL} {
    padding: 50px 26px;
    width: 384px;
    height: 274px;
    margin: 0 24px;
  }

  @media ${deviceMin.tablet} {
    padding: 40px 36px;
    width: 494px;
    height: 262px;
    margin: 0 80px;
  }

  @media ${deviceMin.laptopL} {
    padding: 40px 36px;
    width: 494px;
    height: 262px;
    margin: 0 100px;
  }

  @media ${deviceMin.desktop} {
    padding: 70px 50px;
    width: 716px;
    height: 394px;
    margin-left: 0 0 0 26px;
  }

  .carousel {
    height: 300px;
    position: relative;
  }
`;

export const StyledTitle = styled.p`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font24}
    color: ${COLORS.mainColor};

  @media ${deviceMin.mobileS} {
    ${FONTS.font16}
    margin-bottom: 16px;
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font28}
    margin-bottom: 24px;
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font28}
    margin-bottom: 24px;
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font36}
    margin-bottom: 34px;
  }
`;

export const StyledSubTitle = styled.p`
  color: ${COLORS.mainColor};

  @media ${deviceMin.mobileS} {
    ${FONTS.font16}
    margin-bottom: 20px;
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font16}
    margin-bottom: 20px;
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font16}
    margin-bottom: 20px;
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font24}
    margin-bottom: 50px;
  }
`;

export const StyledButton = styled.button`
  background: ${COLORS.mainColor};
  border-radius: 8px;
  color: ${COLORS.white};
  text-transform: capitalize;
  padding-top: 12px;
  padding-bottom: 12px;
  ${FONTS.font20}
  border:none;

  :hover {
    background: ${COLORS.mainColor_op7};
  }

  @media ${deviceMin.mobileS} {
    width: 202px;
    height: 48px;
    ${FONTS.font16}
  }

  @media ${deviceMin.mobileL} {
    width: 202px;
    height: 52px;
    ${FONTS.font16}
  }

  @media ${deviceMin.desktop} {
    width: 246px;
    height: 64px;
    ${FONTS.font20}
  }
`;

export const StyledTextContainer = styled.button``;

export const StyledSliderContainer = styled.div`
  img {
    object-fit: cover;
  }
`;
